import React from "react";
import Preloader from "../helper/Preloader";
import ColorInit from "../helper/ColorInit";


import Breadcrumb from "../components/Breadcrumb";

import CartSection from "../components/CartSection";
import Shipping from "../components/Shipping";
import ScrollToTop from "react-scroll-to-top";


const CartPage = () => {



  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />


      {/* Breadcrumb */}
      <Breadcrumb title={"Cart"} />

      {/* CartSection */}
      <CartSection />

      {/* Shipping */}
      <Shipping />

    </>
  );
};

export default CartPage;
